module.exports = __webpack_public_path__ + "img/male.6863afb9.svg";